<template>
  <div>
    <j-modal
      centered
      switchFullscreen
      fullscreen
      :title="title"
      :width="1500"
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="关闭">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :xl="4" :lg="5" :md="6" :sm="12">
              <a-form-item label="题库">
                <j-dict-select-tag placeholder="请选择题库" 
                :trigger-change="true"
                @change="questionLibraryChange"
                v-model="queryParam.questionLibrary"
                dictCode="question_library" />
              </a-form-item>
            </a-col>
            <a-col :xl="4" :lg="5" :md="6" :sm="12">
              <a-form-item label="状态">
                <j-dict-select-tag placeholder="请选择状态" v-model="queryParam.questionStatus" dictCode="question_status" />
              </a-form-item>
            </a-col>
            <a-col :xl="3" :lg="4" :md="4" :sm="12">
              <a-form-item label="ID">
                <a-input placeholder="请输入题目ID" v-model="queryParam.id"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="4" :lg="4" :md="4" :sm="12">
              <a-form-item label="题型">
                <j-dict-select-tag placeholder="请选择题型" v-model="queryParam.questionType" dictCode="question_type" />
              </a-form-item>
            </a-col>
            <a-col :xl="5" :lg="6" :md="7" :sm="24">
              <a-form-item label="难度">
                <j-dict-select-tag placeholder="请选择难度" v-model="queryParam.questionDifficulty" dictCode="question_difficulty" />
              </a-form-item>
            </a-col>
            <a-col :xl="5" :lg="6" :md="7" :sm="12">
              <a-form-item label="题目名">
                <a-input placeholder="请输入题目名" v-model="queryParam.questionName"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="5" :lg="6" :md="7" :sm="12">
              <a-form-item label="题干">
                <a-input placeholder="请输入题干关键词" v-model="queryParam.questionStem"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="5" :lg="6" :md="7" :sm="12">
              <a-form-item label="题目标签">
                <j-category-select placeholder="请选择题目标签" v-model="queryParam.tag" pcode="A04" :autoExpand="false" />
              </a-form-item>
            </a-col>
            <a-col :xl="5" :lg="6" :md="7" :sm="12">
              <a-form-item label="知识点">
                <j-category-select placeholder="请选择知识点" v-model="queryParam.knowledgePoint" pcode="A07" :autoExpand="false" />
              </a-form-item>
            </a-col>
            <a-col :xl="5" :lg="6" :md="7" :sm="12">
              <a-form-item label="命题任务">
              <j-search-select-tag placeholder="请选择所属命题任务" v-model="queryParam.taskId" dict="teaching_question_task,task_name,id"/>
              </a-form-item>
            </a-col>
            <a-col :span="3">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- table区域-begin -->
      <div>
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
          <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
          >项
          <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        </div>
        <a-table
          size="small"
          bordered
          rowKey="id"
          :columns="columns1"
          :dataSource="dataSource1"
          :pagination="ipagination"
          :loading="loading"
          :scroll="{ y: 440 }"
          :rowSelection="{selectedRowKeys: selectedRowKeys,onSelectAll:onSelectAll,onSelect:onSelect,onChange: onSelectChange}"
          @change="handleTableChange">
          <template slot="stemView" slot-scope="props">
            <a-popover title="题干预览" placement="right">
              <div slot="content" v-html="props"></div>
              <a-icon type="eye" theme="twoTone" />
            </a-popover>
          </template>
        </a-table>
      </div>
      <!-- table区域-end -->
    </j-modal>
  </div>
</template>

<script>
  import {filterObj} from '@/utils/util'
  import {getAction} from '@/api/manage'
  import { loadCategoryData } from '@/api/api'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
  import JCategorySelect from '@comp/jeecg/JCategorySelect'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'

  export default {
    name: "TSelectQuestionModal",
     components: {
      JCategorySelect,
      JSearchSelectTag
    },
    props:{
      multi:{
        type:Boolean,
        default:false,
        required:false
      },
      title:{
        type:String,
        default: "选择题目"
      }
    },
    data() {
      return {
        names: [],
        visible: false,
        placement: 'right',
        description: '',
        // 查询条件
        queryParam: {
          questionLibrary: undefined,
          questionStatus: undefined
        },
        // 表头
        columns1: [
          // {
          //   title: '#',
          //   dataIndex: '',
          //   key: 'rowIndex',
          //   width: 50,
          //   align: "center",
          //   customRender: function (t, r, index) {
          //     return parseInt(index) + 1;
          //   }
          // },
          {
            title:'题目ID',
            align:"center",
            width: 130,
            dataIndex: 'id'
          },
          {
            title:'题目名',
            align:"center",
            width: 200,
            sorter: true,
            dataIndex: 'questionName'
          },
          {
            title:'题型',
            align:"center",
            width: 80,
            sorter: true,
            dataIndex: 'questionType_dictText'
          },
          {
            title:'难度',
            align:"center",
            width: 60,
            dataIndex: 'questionDifficulty_dictText',
            sorter: true,
          },
          {
            title: '知识点',
            align: "center",
            dataIndex: 'knowledgePoint',
            width: 200,
            customRender: (text) => (text ? filterMultiDictText(this.dictOptions['knowledgePoint'], text, true) : '')
          },
          {
            title: '题目标签',
            align: "center",
            dataIndex: 'tag',
            width: 200,
            customRender: (text) => (text ? filterMultiDictText(this.dictOptions['tag'], text, true) : '')
          },
          {
            title:'参考分',
            align:"center",
            width: 80,
            sorter: true,
            dataIndex: 'questionScore'
          },
          {
            title:'题干',
            align:"center",
            width: 50,
            dataIndex: 'questionStem',
            scopedSlots: { customRender: 'stemView' },
          },
          {
            title:'创建时间',
            align:"center",
            width: 120,
            dataIndex: 'createTime',
            sorter: true,
          }
        ],
        //数据集
        dataSource1: [],
        dataSource2: [],
        // 分页参数
        ipagination: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '50', '100'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " 共" + total + "条"
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        isorter: {
          column: 'createTime',
          order: 'desc',
        },
        loading: false,
        selectedRowKeys: [],
        selectedRows: [],
        url: {
          list: "/teaching/teachingQuestion/list",
        },
        dictOptions: {},
      }
    },
    created() {
      // this.initDictConfig();
      // this.loadData();
    },
    methods: {
      open(){
        this.visible = true
        this.loadData();
      },
      searchQuery() {
        let stem = this.queryParam.questionStem
        if (stem) {this.queryParam.questionStem = "*" + stem + "*"}
        // let tag = this.queryParam.tag
        // if(tag){this.queryParam.tag = "*" + tag + "*"}
        // let knowledgePoint = this.queryParam.knowledgePoint
        // if(knowledgePoint){this.queryParam.knowledgePoint = "*"+knowledgePoint+"*"}
        this.loadData(1);
        this.queryParam.questionStem = stem
        this.selectedRowKeys = [];
        this.selectedRows = [];
        // this.queryParam.tag = tag
        // this.queryParam.knowledgePoint = knowledgePoint
      },
      searchReset() {
        this.queryParam = {};
        this.loadData(1);
      },
      handleCancel() {
        this.selectedRowKeys = [];
        this.selectedRows = [];
        this.visible = false;
      },
      handleOk() {
        if(!this.multi && this.selectedRowKeys.length > 1){
          this.$message.info('只能选择一个题目')
          return
        }
        // this.dataSource2 = this.selectedRowKeys;
        this.selectedRows = this.dataSource2
        console.log("select question rows");
        console.log(this.selectedRows);    
        console.log(this.selectedRowKeys);    
        this.$emit("ok", this.selectedRows, this.selectedRowKeys);
        this.visible = false;
        this.selectedRowKeys = [];
        this.selectedRows = [];
      },
      add() {
        this.visible = true;
      },
      loadData(arg) {
        this.initDictConfig();
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        var params = this.getQueryParams();//查询条件
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource1 = res.result.records;
            this.ipagination.total = res.result.total;
          }
        })
      },
      getQueryParams() {
        var param = Object.assign({}, this.queryParam, this.isorter);
        param.field = this.getQueryField();
        param.pageNo = this.ipagination.current;
        param.pageSize = this.ipagination.pageSize;
        return filterObj(param);
      },
      getQueryField() {
        //TODO 字段权限控制
      },
      onSelectAll(selected, selectedRows, changeRows) {
        if (selected === true) {
          for (var a = 0; a < changeRows.length; a++) {
            this.dataSource2.push(changeRows[a]);
          }
        } else {
          for (var b = 0; b < changeRows.length; b++) {
            this.dataSource2.splice(this.dataSource2.indexOf(changeRows[b]), 1);
          }
        }
      },
      onSelect(record, selected) {
        if (selected === true) {
          this.dataSource2.push(record);
        } else {
          var index = this.dataSource2.indexOf(record);
          //console.log();
          if (index >= 0) {
            this.dataSource2.splice(this.dataSource2.indexOf(record), 1);
          }
        }
      },
      onSelectChange(selectedRowKeys, selectedRows) {
        console.log(selectedRowKeys);
        console.log(selectedRows);
        this.selectedRowKeys = selectedRowKeys;
        this.selectedRows = selectedRows;
      },
      onClearSelected() {
        this.selectedRowKeys = [];
        this.selectedRows = [];
      },
      handleDelete: function (record) {
        this.dataSource2.splice(this.dataSource2.indexOf(record), 1);
      },
      handleTableChange(pagination, filters, sorter) {
        //分页、排序、筛选变化时触发
        console.log(sorter);
        //TODO 筛选
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipagination = pagination;
        this.loadData();
      },
      questionLibraryChange(v) {
        this.queryParam.questionLibrary = v.target.value
        this.loadData()
      },
      initDictConfig() {
        loadCategoryData({ code: "A04" }).then((res) => {
          if (res.success) {
            this.$set(this.dictOptions, 'knowledgePoint', res.result)
          }
        })
        loadCategoryData({ code: "A07" }).then((res) => {
        if (res.success) {
          this.$set(this.dictOptions, 'knowledgePoint', res.result)
        }
      })
      },
    }
  }
</script>
<style lang="less" scoped>
  .ant-card-body .table-operator {
    margin-bottom: 18px;
  }

  .ant-table-tbody .ant-table-row td {
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .anty-row-operator button {
    margin: 0 5px
  }

  .ant-btn-danger {
    background-color: #ffffff
  }

  .ant-modal-cust-warp {
    height: 100%
  }

  .ant-modal-cust-warp .ant-modal-body {
    height: calc(100% - 110px) !important;
    overflow-y: auto
  }

  .ant-modal-cust-warp .ant-modal-content {
    height: 90% !important;
    overflow-y: hidden
  }
</style>